declare global {
  /** Variable is defined by webpack.DefinePlugin during the build process. */
  const __VERSION__: string;
}

export const VERSION: string = __VERSION__;
